// this is for pdfs and other binary files.  we want to keep assets.thi just for images
export const getFileUrl = function (folder, filename) {
    // bad data
    if (!folder || !filename) return undefined
    return `https://static.thiecommerce.com/assets/${this.$config.platform.mode}/${folder}/${filename}`
}
